import { render, staticRenderFns } from "./PrivateRateSingle.vue?vue&type=template&id=44ecfe4b&scoped=true&"
import script from "./PrivateRateSingle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PrivateRateSingle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PrivateRateSingle.vue?vue&type=style&index=0&id=44ecfe4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ecfe4b",
  null
  
)

export default component.exports